import styled from 'styled-components'
import { BannerComponent } from 'Pages/landings/newLandings/common/components'
import { media, Breakpoints } from 'Pages/landings/newLandings/common/style'

export const Banner = styled(BannerComponent)`
	${media('padding-right: 48%;', Breakpoints.ms)};
	${media('padding-right: 40%;', Breakpoints.lx)};
	${media('padding-right: 50%;', Breakpoints.xl)};
`
